import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd89c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "reply-box"
}
const _hoisted_2 = { class: "reply-list" }
const _hoisted_3 = {
  key: 0,
  class: "fetch-more"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-v-d6f79dbc": "",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.99976 7.93206L10.0656 3.86619C10.1633 3.76856 10.3215 3.76856 10.4192 3.86619L10.7727 4.21975C10.8704 4.31738 10.8704 4.47567 10.7727 4.5733L6.35331 8.99272C6.15805 9.18798 5.84147 9.18798 5.6462 8.99272L1.22679 4.5733C1.12916 4.47567 1.12916 4.31738 1.22679 4.21975L1.58034 3.86619C1.67797 3.76856 1.83626 3.76856 1.93389 3.86619L5.99976 7.93206Z"
  })
], -1))

import { computed, inject, reactive } from 'vue'
import ContentBox from './content-box.vue'
import { ReplyApi, InjectionReply, ReplyParam } from '~/index'

interface Props {
  data?: ReplyApi | null
  parentId: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'reply-box',
  props: {
    data: null,
    parentId: null
  },
  setup(__props: any) {

const props = __props as {
  data?: ReplyApi | null
  parentId: number
}


const state = reactive({
  loading: false,
  over: false,
  pageNum: 1,
  pageSize: 4
})

const data = computed(() => {
  if (!props.data) {
    return {
      total: 0,
      list: []
    }
  }
  return props.data
})

const replyInject = inject(InjectionReply) as ReplyParam

const replyMore = () => {
  state.loading = true
  state.over = true
  replyInject.replyMore(props.parentId, () => (state.loading = false))
}

const currentChange = (val: number) => {
  state.pageNum = val
  replyInject.replyPage(props.parentId, val, state.pageSize)
}

const sizeChange = (val: number) => {
  state.pageSize = val
  replyInject.replyPage(props.parentId, state.pageNum, val)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_unref(data).total > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (reply, index) => {
            return (_openBlock(), _createBlock(ContentBox, {
              key: index,
              "parent-id": __props.parentId,
              data: reply,
              small: ""
            }, {
              userInfo: _withCtx(() => [
                _renderSlot(_ctx.$slots, "userInfo")
              ]),
              _: 2
            }, 1032, ["parent-id", "data"]))
          }), 128)),
          (_unref(data).total > 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (state.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "加载中..."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (!state.over)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createTextVNode(" 共" + _toDisplayString(_unref(data).total) + "条回复, ", 1),
                            _createElementVNode("span", {
                              class: "fetch-more-comment select-none",
                              onClick: replyMore
                            }, [
                              _createTextVNode(" 点击查看 "),
                              _hoisted_7
                            ])
                          ]))
                        : (_openBlock(), _createBlock(_component_el_pagination, {
                            key: 1,
                            small: "",
                            "hide-on-single-page": "",
                            layout: "total, prev, pager, next",
                            total: _unref(data).total,
                            "page-size": state.pageSize,
                            onCurrentChange: currentChange,
                            onSizeChange: sizeChange
                          }, null, 8, ["total", "page-size"]))
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})